import { z } from 'zod/v4';

export const restrictionTypeOptions = ['allow', 'avoid', 'warn'] as const;

export const restrictionTypeSchema = z.enum(restrictionTypeOptions);

export type RestrictionType = z.infer<typeof restrictionTypeSchema>;
